import { MeterKeysTab } from "@/components/settings/meter-keys-tab";

export function MeterKeysPage() {
	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<MeterKeysTab />
		</div>
	);
}
